import { TranslationFunction, ComplexTranslation } from '@cbre/alerts';
import { L10nTranslationService } from 'angular-l10n';

export function TranslationFunctionFactory(translationService: L10nTranslationService): TranslationFunction {
  return function translateString(message: string | ComplexTranslation): string {
    return typeof message === 'string'
      ? translationService.translate(message)
      : translationService.translate(message.message, message.params);
  };
}
